import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

const tagName = 'div';

register('wms-design-quick-actions', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          return `<${tagName} wmsDesignQuickActions ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
